import { atom } from 'recoil';
import { atom as jotaiAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import type { Utils } from '@sparrow-marketing/contracts';
import type { CollapseStatus, QuickStartSetup } from './types';

export type ActivationFlowTypes =
  | 'account'
  | 'datasources'
  | 'destination'
  | 'report';

export const QuickStartState = atom<
  Utils.DynamicObject<Exclude<QuickStartSetup, 'dashboard'>, CollapseStatus>
>({
  key: 'quick-start-setup-key',
  default: {
    account: 'completed',
    datasources: 'pending',
    destination: 'pending',
    report: 'pending',
  },
});

export const QuickStartActiveStepState = atom<QuickStartSetup>({
  key: 'quick-start-active-step',
  default: 'datasources',
});

export const QuickStartDatasourceModal = atom<boolean>({
  key: 'quick-start-datasource-modal',
  default: false,
});

// Jotai atom with localStorage for activation state
export interface ActivationState {
  account: CollapseStatus;
  datasources: CollapseStatus;
  destination: CollapseStatus;
  report: CollapseStatus;
}

export const activationStateAtom = atomWithStorage<ActivationState>(
  'activation-state-v1',
  {
    account: 'completed',
    datasources: 'pending',
    destination: 'pending',
    report: 'pending',
  }
);
